import React, {Component, Fragment} from "react";
import {withTranslation} from "react-i18next";
import Dropzone from "react-dropzone";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {fileUpload, notificationUploadFiles} from "../../store/components/smartDropzone/actions";
import {sha1} from "crypto-hash";
import {Row, Col} from "reactstrap";
import {formatBytes} from "../../common/general";

const FilePhase = {
  Sent: "Sent",
  Upload: "Upload",
  Done: "Done",
  Error: "Error",
}

class SmartDropzone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
    this.onUploadSuccess = this.onUploadSuccess.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
    }
  }

  onUploadSuccess(response) {
    if (response.status === 0) {
      setTimeout((id) => {
        this.updateFiles(id, FilePhase.Done)
      }, 500, response.response.id);
    } else if (response.status === 1) {
      setTimeout((id) => {
        this.updateFiles(id, FilePhase.Error)
      }, 500, response.response.id);
    }
  }

  handleDropzone(files) {
    this.props.onNotificationUploadFiles({data: {count: files.length, section_id: this.props.sectionId, segment_id: this.props.segmentId}, history: this.props.history})
    files.map(file => this.uploadFile(file))
  }

  async uploadFile(file) {
    const formData = new FormData()
    const id = (await sha1(file.name + file.size + Date.now())).slice(0, 10)
    formData.append('id', id)
    formData.append('sectionId', this.props.sectionId)
    formData.append('segmentId', this.props.segmentId)
    formData.append('file', file)
    this.setState((prevState) => ({
      files: [
        ...prevState.files,
        {id: id, name: file.name, size: file.size, phase: FilePhase.Sent}
      ]
    }))
    this.props.onFileUpload({url: this.props.uploadUrl, segmentId: this.props.segmentId, file: formData, uploadSuccess: this.onUploadSuccess, history: this.props.history})
    setTimeout((id) => {
      this.updateFiles(id, FilePhase.Upload)
    }, 250, id);
  }

  updateFiles(id, phase) {
    this.setState((prevState) => ({
      files: prevState.files.map(file => {
        if (file.id === id) {
          file.phase = phase
        }
        return file
      })
    }))
    if (phase === FilePhase.Done) {
      setTimeout((id) => {
        this.deleteFiles(id)
      }, 3000, id);
    } else if (phase === FilePhase.Error) {
      setTimeout((id) => {
        this.deleteFiles(id)
      }, 10000, id);
    }
  }

  deleteFiles(id) {
    this.setState((prevState) => {
      const newFiles = prevState.files.filter(file => file.id !== id)
      if (prevState.files.length > 0 && newFiles.length === 0) {
        this.props.refreshSegments()
      }
      return ({
        files: newFiles
      })
    })
  }

  render() {
    return (
      <Fragment>
        <Dropzone onDrop={files => this.handleDropzone(files)} styles={{dropzone: {minHeight: 200, maxHeight: 250}}}>
          {({getRootProps, getInputProps}) => (
            <div className="dropzone mt-3">
              <div className="dz-message needsclick" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="mb-3">
                  <i className="display-4 text-muted bx bxs-cloud-upload"/>
                </div>
                <h5>Drop files here or click to upload</h5>
              </div>
            </div>
          )}
        </Dropzone>
        <div>
          {this.state.files.map(file => {
            return (
              <Row key={file.id}>
                <Col md={12} className="text-info">{file.name}</Col>
                <Col md={8} className="" style={{"fontSize": ".7rem"}}>{formatBytes(file.size)}</Col>
                <Col md={4} className="" style={{"fontSize": ".7rem"}}>
                  {file.phase === FilePhase.Sent && <span className="badge rounded-pill bg-info">{file.phase}</span>}
                  {file.phase === FilePhase.Upload && <span className="badge rounded-pill bg-warning">{file.phase}</span>}
                  {file.phase === FilePhase.Done && <span className="badge rounded-pill bg-success">{file.phase}</span>}
                  {file.phase === FilePhase.Error && <span className="badge rounded-pill bg-danger">{file.phase}</span>}
                </Col>
              </Row>
            )
          })}
        </div>
      </Fragment>
    );
  }
}

SmartDropzone.propTypes = {
  onFileUpload: PropTypes.func,
  onNotificationUploadFiles: PropTypes.func,
};

const mapStateToProps = ({SmartDropzone}) => ({
  loading: SmartDropzone.loadingUpload,
  error: SmartDropzone.errorUpload,
});

const mapDispatchToProps = dispatch => ({
  onFileUpload: data => dispatch(fileUpload(data)),
  onNotificationUploadFiles: data => dispatch(notificationUploadFiles(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmartDropzone));